import { Accuracy, BusinessSecure, Efficiancy, FocusForward, Price, Scalability } from "../../../Components/BusinessIcons";
import ContainerSize from "../../../Components/container";
import SEO from "../../../Components/SEO";
import ServicesContent from "../../../Components/ServicesContent";
import ServicesCardInformation from "../ServicesCards";
const WebApplicationServise = () => {

    const insuranceKeywords = [
        "website design services in USA",
        "professional website design services USA",
        "best web design company in USA",
        "website design agency in Texas",
        "custom website design USA",
        "business website design USA",
        "hire web designer in the USA",
        "website designers in USA",
        "affordable website design in California",
        "small business website design all over the USA",
        "corporate website design in New York",
        "custom web design company USA",
        "responsive website design USA",
        "SEO-friendly website design USA",
        "WordPress website design USA",
        "e-commerce website design USA",
        "landing page design services USA",
        "UI UX website design USA",
        "website design services in United States",
        "web design company in USA",
        "US-based website design services",
        "website design services for US businesses",
        "website design services New York",
        "website design services California",
        "website design services Texas",
        "best website design services in Indiana",
        "professional web designers for US businesses",
        "affordable web design services for small businesses USA",
        "custom website design services in the USA",
        "best web design services around the USA",
        "website maintenance",
        "full-stack web applications",
        "end-to-end web application services",
        "making web designer near me"
    ];

    const cardItems = [
        {
            icon: (
                <BusinessSecure />
            ),
            title: 'Strategic Scalability',
            description:
                'We build applications that grow with your ambitions. For a small business, this means a clean, lean foundation that’s easy to manage. For large-scale industries, it means a robust architecture capable of handling millions of URLs, complex JavaScript rendering and massive traffic spikes without compromising performance.',
        },
        {
            icon: (
                <FocusForward />
            ),
            title: 'Local-to-National SEO Precision',
            description:
                'At Imash Insurance, we believe your business should focus on what truly matters growth, efficiency and your core business goals. Our back-office and outsourcing solutions are designed to handle your operational burden, freeing you to concentrate on what you do best.',
        },
        {
            icon: (
                <Price />

            ),
            title: 'Agile Growth & ROI Analytics',
            description:
                `Web applications are living products. We provide continuous optimization based on real-time data. Using advanced analytics, we track how USA-based users interact with your app, allowing us to pivot strategies, improve conversion rates (CRO) and ensure every dollar spent on SEO delivers a measurable return.`
        },
        {
            icon: (
                <Scalability />

            ),
            title: 'Technical Integrity & Core Web Vitals',
            description:
                'In the USA, where Google’s standards are the gold standard, speed is a ranking factor. Our web applications are engineered for "lightning-fast" load times and pass every Core Web Vitals test. We ensure your technical foundation from HTTPS security to Schema Markup is flawless, so search engines can easily index your value.',
        },
        {
            icon: (
                <Efficiancy />

            ),
            title: 'Data-Driven Keyword Intelligence',
            description:
                'We don’t just build; we research. Our strategy involves identifying the high-intent keywords that your specific industry needs. We target "long-tail" keywords for small niche businesses to ensure quick wins and "head terms" for large-scale industries to establish market dominance.',
        },
        ,
        {
            icon: (
                <Accuracy />

            ),
            title: 'Content Authority & E-E-A-T',
            description:
                'A great web app needs a voice. We focus on E-E-A-T (Experience, Expertise, Authoritativeness and Trustworthiness) to ensure your site is viewed as a leader by both users and algorithms. Whether it’s helpful blog clusters for a local shop or white papers for a manufacturer, our content is designed to convert.'
        },
    ];
    const servicesCardData = [
        {
            heading: "Custom Web Design",
            descriptions: `Custom web design elevates your brand with bespoke websites for US businesses nationwide, built on WordPress, Web-flow, and Shopify for scalability and performance. Our designers create responsive websites optimized for search visibility and organic traffic. From startups to enterprises, we focus on brand identity, fast-loading pages, and conversion-focused layouts that increase user engagement. Services include seamless E‑commerce integration, mobile-first responsiveness, and future-ready designs aligned with 2026 AI trends, delivered remotely across the United States. Partner with us for cost-effective, results-driven custom web solutions that strengthen your online presence nationwide.`
        },
        {
            heading: "UI/UX Optimization",
            descriptions: `UI/UX optimization enhances user experiences with intuitive interfaces designed for US businesses nationwide. Our services include wireframing, prototyping, and accessibility-focused design to improve usability and engagement. We refine layouts for strong search visibility and consistent performance across devices. From startups to enterprises, we deliver clear navigation, smooth interactions, and personalized user journeys that support retention and long-term growth. Mobile-first design ensures responsive performance aligned with 2026 trends such as AI-driven personalization and voice-enabled experiences. Our scalable UI/UX solutions are delivered remotely across the United States, helping businesses build effective, user-focused digital products.`
        },
        {
            heading: "Responsive & E-commerce Design",
            descriptions: `Responsive and E-Commerce design services deliver mobile-first websites and online stores for US businesses nationwide, ensuring consistent performance across all devices. Our solutions focus on responsive layouts and E-commerce best practices to support search visibility and qualified traffic. From startups to enterprises, we build fast, scalable platforms with intuitive shopping experiences, secure payment integration, and efficient product and inventory management. Features include product displays, customer reviews, cart recovery functionality, and SEO-ready structures aligned with evolving trends such as voice-enabled shopping and interactive product experiences. Delivered remotely across the United States, our cost-effective designs help improve engagement, support conversions, and strengthen long-term E-commerce growth.`
        },
        {
            heading: "SEO-Integrated Development",
            descriptions: `SEO-integrated development builds websites from the ground up with search engine optimization embedded in every layer, ensuring US businesses rank higher for competitive terms like "SEO web development USA" and dominate Google results nationwide. Our approach combines technical SEO fast loading speeds, schema markup, mobile optimization with content strategies that target high-volume keywords, driving 200%+ organic traffic growth for startups to enterprises across all states. We implement core web vitals, secure HTTPS, XML sitemaps and crawl-friendly architecture while aligning with 2026 algorithm updates like AI search and E-E-A-T signals. Enjoy future-proof sites with built-in analytics, local SEO for regional dominance and conversion-focused elements that reduce bounce rates and boost dwell time. Delivered remotely with measurable ROI, our services outperform traditional development by prioritizing visibility, scalability and sustained rankings coast-to-coast.`
        },
        {
            heading: "Redesign & Maintenance",
            descriptions: `Redesign and maintenance services refresh existing websites for US businesses nationwide through structured audits, smooth migrations, and ongoing support to maintain security, performance, and search visibility. We focus on website redesign and maintenance best practices by resolving technical issues, updating content, and improving site speed to enhance usability. From startups to enterprises across the United States, services include regular backups, software and plugin updates, security monitoring, and performance tracking aligned with modern standards such as Core Web Vitals and data privacy requirements. Our process preserves site structure and SEO value during redesigns while introducing updated UI/UX enhancements for improved engagement. Delivered remotely with flexible maintenance plans, these services support stability, consistency, and long-term website performance nationwide.`
        }

    ];
    return (
        <>
            <SEO
                title="Professional Website Design Services | Grow Your Business"
                description="Get custom, mobile-friendly website design services in the USA. SEO-optimized, fast loading websites built to grow your business."
                keywords={insuranceKeywords.join(",")}
            />
            <ServicesContent servicesCardData={servicesCardData} />
            <ContainerSize>
                <ServicesCardInformation cardItems={cardItems} />
            </ContainerSize>
        </>
    )
}
export default WebApplicationServise